import { useLayoutEffect, useState } from "react";
const useImageDimensions = ({
  src,
  containerData,
  image
}) => {
  const [dimensions, setDimensions] = useState({
    width: void 0,
    height: void 0
  });
  const width = image?.width || Number(containerData?.width?.custom) || dimensions.width;
  const height = image?.height || Number(containerData?.height?.custom) || dimensions.height;
  useLayoutEffect(() => {
    if (typeof width === "number" && typeof height === "number") {
      return;
    }
    setDimensions({ width: void 0, height: void 0 });
    if (!src) {
      return;
    }
    const newImg = new Image();
    newImg.onload = () => setDimensions({ width: newImg.width, height: newImg.height });
    newImg.src = src;
    return () => {
      newImg.onload = null;
    };
  }, [src]);
  return {
    width,
    height
  };
};
export {
  useImageDimensions
};
//# sourceMappingURL=use-image-dimensions.js.map
